<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Push') != -1" type="primary" class="btn primary" @click="push">确认上传</el-button>

          <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary" @click="exportData" v-loading="exportButtonLoading" :disabled="exportButtonLoading">导出</el-button>
          <el-button type="primary" class="btn primary" @click="updateOrderState">重置状态</el-button>

          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
        </div>
      </div>

      <!-- row-key="id"  :span-method="objectSpanMethod"-->
      <el-table ref="multipleTable" border v-loading="loading" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <!-- :reserve-selection="true" -->
        <el-table-column fixed prop="selection" type="selection" width="55" align="center"></el-table-column>
        <el-table-column prop="no" min-width="170" label="院支付单号" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.no?scope.row.no:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="createdUserName" min-width="80" label="创建人" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.createdUserName?scope.row.createdUserName:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" min-width="150" label="创建时间" show-overflow-tooltip>
          <template slot-scope="scope">{{
            scope.row.createdTime?
            parseTime(new Date(scope.row.createdTime)):'-'
          }}</template>
        </el-table-column>
        <el-table-column prop="supplierName" min-width="100" label="收款方" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.supplierName?scope.row.supplierName:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="priceMonitorPayOrderCode" min-width="150" label="平台支付单号" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.priceMonitorPayOrderCode?scope.row.priceMonitorPayOrderCode:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="purchaseOrderNo" min-width="120" label="院采购单号" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.purchaseOrderNo?scope.row.purchaseOrderNo:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="acceptInStockNo" min-width="120" label="院入库单号" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.acceptInStockNo?scope.row.acceptInStockNo:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="priceMonitorDistributeId" min-width="150" label="平台配送单明细编号" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.priceMonitorDistributeId?scope.row.priceMonitorDistributeId:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="productName" min-width="120" label="产品名称" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.productName?scope.row.productName:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="specName" min-width="120" label="规格型号" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.specName?scope.row.specName:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="number" min-width="90" label="结算数量" show-overflow-tooltip></el-table-column>
        <el-table-column prop="amount" min-width="90" label="结算金额" show-overflow-tooltip></el-table-column>
        <el-table-column prop="billNo" min-width="90" label="发票号码" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.billNo?scope.row.billNo:'-' }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="inStockPriceMonitorStateName" min-width="120" label="入库单上传状态" show-overflow-tooltip></el-table-column> -->

        <el-table-column prop="uploadTime" min-width="150" label="上传时间" show-overflow-tooltip>
          <template slot-scope="scope">{{
            scope.row.uploadTime?
            parseTime(new Date(scope.row.uploadTime)):'-'
          }}</template>
        </el-table-column>
        <el-table-column fixed="right" prop="priceMonitorStateName" min-width="100" label="数据状态" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  GetFinances,
  PushPayOrderToProduct,
  UpdatePriceMonitorPayOrderState,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  PriceMonitorOrderTypeOptions,
  PriceMonitorPushStateOptions,
  PriceMonitorCompareStateOptions,
  PriceMonitorPriceStateOptions,
  PriceMonitorOrderStateOptions,
} from "@/enum";
import SelectFilter from "@/components/table-select-filter";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    SelectFilter,
  },
  data () {
    return {
      // exportAction: ExportPriceMonitorOrder,
      GetDatasAction: GetFinances,

      PriceMonitorOrderTypeOptions: PriceMonitorOrderTypeOptions,
      PriceMonitorPriceStateOptions: PriceMonitorPriceStateOptions,
      PriceMonitorCompareStateOptions: PriceMonitorCompareStateOptions,
      PriceMonitorPushStateOptions: PriceMonitorPushStateOptions,
      PriceMonitorOrderStateOptions: PriceMonitorOrderStateOptions,
      filterOptions: [
        {
          name: "数据状态",
          type: "select",
          code: "state",
          data: PriceMonitorPushStateOptions,
        },
        {
          name: "上传时间",
          type: "uploadDate",
          code: "date",
          startDateCode: "uploadStartTime",
          endDateCode: "uploadEndTime",
        },
        {
          name: "创建人",
          type: "select",
          code: "createdUser",
          filterMethod: this.getUsers,
          data: [],
        },
        {
          name: "创建时间",
          type: "date",
          code: "date",
          defaultValue: this.getDefaultDateRange(), // [new Date(new Date().setDate(new Date().getDate() - 7)), new Date()],//],
          startDateCode: "startDate",
          endDateCode: "endDate",
        },
        {
          name: "院支付单号",
          type: "input",
          code: "invoiceRegisterNo",
        },
        {
          name: "收款方",
          type: "input",
          code: "supplierName",
        },
        {
          name: "平台支付单号",
          type: "input",
          code: "priceMonitorPayOrderCode",
        },
        {
          name: "供应商产品编码",
          type: "input",
          code: "supplierProductNo",
        },
        {
          name: "产品名称",
          type: "input",
          code: "productName",
        },
        {
          name: "规格型号",
          type: "input",
          code: "specName",
        },

      ],
      spanArr: [],
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        priceMonitorType: 1,
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      // orderDetailIds
      priceMonitorDetailIds: [],
    };
  },
  methods: {
    handleSelectionChange (selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.priceMonitorDetailIds = selection.map((item) => item.priceMonitorDetailId);
      this.multiple = !selection.length;
      console.log("selection", selection);
    },
    // 获取列表
    getData () {
      console.log(this.system_setting);
      this.loading = true;
      this.GetDatasAction(this.query)
        .then((res) => {
          this.tableData = res.returnData.data;
          this.total = res.returnData.totalCount;

          // this.getSpanArr(this.tableData);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },

    // 重置
    reset () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        priceMonitorType: 1,
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = [];
      this.multipleSelection = [];
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },

    getDefaultDateRange () {
      var endDate = new Date();
      var start = new Date(new Date().setDate(new Date().getDate() - 6));
      // 开始日期转换为00:00:00
      var startDate = new Date(
        `${start.getFullYear()}-${start.getMonth() + 1}-${start.getDate()} 00:00:00`
      );

      return [startDate, endDate];
    },
    // getSpanArr (data) {
    //   this.spanArr = [];
    //   if (!data) {
    //     return;
    //   }
    //   // data就是我们从后台拿到的数据
    //   for (var i = 0; i < data.length; i++) {
    //     if (i === 0) {
    //       this.spanArr.push(1);
    //       this.pos = 0;
    //     } else {
    //       // 判断当前元素与上一个元素是否相同
    //       if (data[i].no === data[i - 1].no) {
    //         this.spanArr[this.pos] += 1;
    //         this.spanArr.push(0);
    //       } else {
    //         this.spanArr.push(1);
    //         this.pos = i;
    //       }
    //     }
    //     // console.log(this.spanArr);
    //   }
    // },
    // objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
    //   // console.log(column)
    //   var colNames = [
    //     "selection",
    //     "no",
    //     "priceMonitorHospitalId",
    //     "priceMonitorOrderName",
    //     "priceMonitorOrderTypeName",
    //     "priceMonitorDefaultDistributeAddr",
    //     "priceMonitorCreatedTime",
    //     "createdTime",
    //     "createdUserName",
    //   ];
    //   // if (column.property == 'no') { // || column.property == "printingTimes"
    //   if (colNames.indexOf(column.property) != -1) {
    //     const _row = this.spanArr[rowIndex];
    //     const _col = _row > 0 ? 1 : 0;
    //     // console.log(`rowspan:${_row} colspan:${_col}`);
    //     return {
    //       // [0,0] 表示这一行不显示， [2,1]表示行的合并数
    //       rowspan: _row,
    //       colspan: _col,
    //     };
    //   }
    // },


    push () {
      if (!this.ids || this.ids.length == 0) {
        this.$my_message("请选择要上传的订单数据", "warning");
        return;
      }

      var pushedList = this.multipleSelection.filter(
        (e) => e.priceMonitorState == 1
      );
      if (pushedList && pushedList.length > 0) {
        this.$my_message("请选择未上传的明细数据", "warning");
        return;
      }
      // 上传订单
      this.pushOrder();
    },
    pushOrder () {
      PushPayOrderToProduct({ ids: this.ids }).then((res) => {
        this.$my_message("上传成功", "success");

        this.$refs.multipleTable.clearSelection();
        this.getData();
        // this.reset();
      });
    },

    updateOrderState () {
      if (!this.ids || this.ids.length == 0) {
        this.$my_message("请选择要重置状态的明细数据", "warning");
        return;
      }

      this.$my_confirm("此操作将重置所选明细的上传状态，是否继续？", "提示", {
        type: "warning",
      })
        .then(() => {
          return UpdatePriceMonitorPayOrderState({ ids: this.ids });
        })
        .then((res) => {
          this.$my_message("重置成功", "success");
          this.getData();
        });
    },
  },
  mounted () {
    this.getData();
  },
  created () {
    var dateArr = this.getDefaultDateRange();
    this.query.startDate = this.parseTime(dateArr[0]);
    this.query.endDate = this.parseTime(dateArr[1]);
    this.query.priceMonitorType = 0;
  },
};
</script>

<style lang="scss" scoped></style>
